export function LogoMark({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={Math.round((size * 26) / 24)}
      viewBox="0 0 24 26"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12 1.5 22 7.25v11.5L12 24.5 2 18.75V7.25z"
        fill="#FFB800"
        stroke="#1D1A14"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M8 10.5h8M8 14h5.5" stroke="#1D1A14" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
